import MakeTag from "../makeTag/MakeTag";
export default function Love2dTag() {
  return (<>
    <MakeTag tagText="Löve 2D" color="#e9316e" />
    <MakeTag tagText="Lua" color="#0300fc" />
  </>);
}